import * as React from 'react';
import { Trans } from 'react-i18next';

import { AttachmentTrigger } from './components';
import { Box } from '../box';
import { DropboxChooser } from '../dropbox-chooser';
import { GooglePicker } from '../google-picker';
import { GoogleService } from 'old/services/GoogleService';
import { Icon } from '../icon';
import { Menu, MenuButton, MenuList, MenuItem } from '../menu';
import { StorageService } from 'old/services/StorageService';
import { Text } from '../text';
import { Uploader } from '../uploader';

export class AttachmentMenu extends React.Component {
  state = {
    isUploading: false,
  };

  uploaderRef = React.createRef();

  setUploading = (isUploading) => {
    if (!this.props.hiddenText) {
      this.setState({ isUploading });
    }
    this.props.onUpload(isUploading);
  };

  onSelectGoogle = async (data) => {
    if (data.action === 'picked' && window.gapi) {
      this.setUploading(true);

      let response;
      const pickerFile = data.docs[0];
      const accessToken = window.google.accessToken;

      if (pickerFile.type === 'document') {
        response = await GoogleService.exportDriveDoc({
          fileId: pickerFile.id,
          mimeType: 'application/pdf',
          accessToken: accessToken,
        });
      } else {
        response = await GoogleService.getDriveFile(pickerFile.id, accessToken);
      }
      const file = new File([response.data], pickerFile.name, { type: pickerFile.mimeType });

      if (this.props.disableUpload) {
        this.props.onChange([file]);
      } else {
        const responseData = await StorageService.send(file);
        this.props.onChange([responseData.data]);
      }

      this.setUploading(false);
    }
  };

  onSelectDropbox = async (data) => {
    this.setUploading(true);

    if (this.props.disableUpload) {
      const promises = data.map(async (file) => {
        const response = await fetch(file.link);
        const blob = await response.blob();
        blob.name = file.name;
        return blob;
      });

      const files = await Promise.all(promises);

      this.props.onChange(files);
    } else {
      const files = data.map((file) => ({
        name: file.name,
        url: file.link,
      }));

      const promises = files.map((file) => StorageService.send(file));

      const responses = await Promise.all(promises);
      this.props.onChange(responses.map((r) => r.data));
    }

    this.setUploading(false);
  };

  render() {
    const { AttachmentTriggerComponent } = this.props;
    return (
      <Box justifyContent="center" className="attachment-menu">
        <Menu>
          <MenuButton
            style={{ border: 0, background: 'none' }}
            id={`attachment-icon-${this.props.suffixId}`}
            disabled={this.props.disabled}
          >
            {AttachmentTriggerComponent ? (
              <AttachmentTriggerComponent uploading={this.state.isUploading} active={this.props.active} />
            ) : (
              <AttachmentTrigger uploading={this.state.isUploading} active={this.props.active} />
            )}
          </MenuButton>
          <MenuList
            data-reach-menu-list-position={this.props.position}
            style={this.props.positionOffset ? { marginTop: -1 * this.props.positionOffset } : undefined}
            data-test-id="attachment-menu_list"
          >
            <MenuItem
              onSelect={() => {
                if (this.uploaderRef.current) {
                  this.uploaderRef.current.click();
                }
              }}
              className="attachment-menu__item"
              data-test-id="item_computer"
            >
              <Box flexDirection="row" justifyContent="space-between" flex="1">
                <Text color="#fff">
                  <Trans>Your Computer</Trans>
                </Text>
                <Icon size={16} className="attachment-menu__icon" name="image-upload" />
              </Box>
            </MenuItem>

            <MenuItem className="attachment-menu__item" onSelect={() => {}} data-test-id="item_google-drive">
              <GooglePicker onSelect={this.onSelectGoogle}>
                <Box flexDirection="row" justifyContent="space-between" flex="1">
                  <Text color="#fff">
                    <Trans>Google Drive</Trans>
                  </Text>
                  <Icon size={16} className="attachment-menu__icon" name="gdrive" />
                </Box>
              </GooglePicker>
            </MenuItem>

            <MenuItem className="attachment-menu__item" onSelect={() => {}} data-test-id="item_dropbox">
              <DropboxChooser onSelect={this.onSelectDropbox}>
                <Box flexDirection="row" justifyContent="space-between" flex="1">
                  <Text color="#fff">
                    <Trans>Dropbox</Trans>
                  </Text>
                  <Icon size={16} className="attachment-menu__icon" name="dropbox" />
                </Box>
              </DropboxChooser>
            </MenuItem>
          </MenuList>
        </Menu>

        <Uploader
          disableUpload={this.props.disableUpload}
          multiple
          onChange={this.props.onChange}
          setUploading={this.setUploading}
          TriggerComponent={({ uploading }) => <div ref={this.uploaderRef} />}
          id={`attachment-add-${this.props.suffixId}`}
        />
      </Box>
    );
  }
}
